let AbortController;
let crossFetch = fetch;

if (!process.env.IS_BROWSER) {
    const {
        AbortController: _AbortController,
        abortableFetch,
    } = require('abortcontroller-polyfill/dist/cjs-ponyfill');
    const { fetch: _fetch } = abortableFetch(fetch);
    AbortController = _AbortController;
    crossFetch = _fetch;
} else {
    AbortController = window.AbortController;
}

export { crossFetch, AbortController };
